import React, { useState } from 'react'
 
 
import AccountMappingList from './AccountMappingList';
import AccountMappingForm from './AccountMappingForm';

const AccountMapping= () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);

  return (
    <>
      {fromIsShown ? (
          <AccountMappingForm addForm={setFromIsShown} update={upData} />
        ) : (
          <AccountMappingList addForm={setFromIsShown} update={setUpData} />
        )}  
    </>
  )
}

export default AccountMapping